export const ShortTopArrow = () => {
  return (
    <svg
      width="12"
      height="44"
      viewBox="0 0 12 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.77344 2.62269e-07L-6.6638e-05 10L11.5469 10L5.77344 2.62269e-07ZM5.77344 40L6.77344 40L6.77344 9L5.77344 9L4.77344 9L4.77344 40L5.77344 40Z"
        fill="white"
      />
      <rect
        x="8.77344"
        y="38"
        width="6"
        height="6"
        rx="3"
        transform="rotate(90 8.77344 38)"
        fill="white"
      />
    </svg>
  );
};
